import UIIcon from 'UIComponents/icon/UIIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { OverlayedLoadingButton } from 'automation-ui-canvas/containers/undo-redo/styles';
import { useUndoRedo } from 'automation-ui-canvas/containers/undo-redo/useUndoRedo';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const UndoRedoButton = ({
  flowId,
  currentVersion,
  use,
  children,
  requestType
}) => {
  const {
    tooltipMessage,
    isDisabled,
    onClick,
    isLoading,
    revertFailed
  } = useUndoRedo({
    flowId,
    currentVersion,
    requestType
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    title: tooltipMessage,
    placement: "bottom",
    children: /*#__PURE__*/_jsx(OverlayedLoadingButton, {
      "aria-label": requestType === 'UNDO' ? I18n.text('automation.common.undoRedo.undoButtonLabel') : I18n.text('automation.common.undoRedo.redoButtonLabel'),
      onClick: onClick,
      loading: isLoading,
      disabled: isDisabled,
      failed: revertFailed,
      use: use,
      size: "medium",
      trackableKey: requestType === 'UNDO' ? Trackables.CLICKED_UNDO_WORKFLOW_BUTTON : Trackables.CLICKED_REDO_WORKFLOW_BUTTON,
      children: children || requestType === 'UNDO' ? /*#__PURE__*/_jsx(UIIcon, {
        name: "undo"
      }) : /*#__PURE__*/_jsx(UIIcon, {
        name: "redo"
      })
    })
  });
};
export default UndoRedoButton;